// extracted by mini-css-extract-plugin
export var actionButton = "_a1-1";
export var actionButtons = "_a1-2";
export var actions = "_a1-0";
export var aiUnread = "_a1-10";
export var alignCenter = "_a1-h";
export var backWrapper = "_a1-3";
export var cellContainer = "_a1-4";
export var checkboxContainer = "_a1-5";
export var contentContainer = "_a1-6";
export var contentHeader = "_a1-8";
export var conversationsTableWrapper = "_a1-s";
export var draftReplyBadgeContainer = "_a1-m";
export var dropdownItem = "_a1-b";
export var dropdownItemsContainer = "_a1-a";
export var dropdownTitle = "_a1-c";
export var errorIcon = "_a1-7";
export var filter = "_a1-d";
export var gray = "_a1-i";
export var headerActionButtons = "_a1-e";
export var headerCheckboxContainer = "_a1-f";
export var icon = "_a1-j";
export var menuContainer = "_a1-k";
export var noMoreTicketsIcon = "_a1-12";
export var noMoreTicketsSubText = "_a1-13";
export var oneLine = "_a1-l";
export var optionsButton = "_a1-n";
export var plus = "_a1-o";
export var portalButtonsWrapper = "_a1-g";
export var red = "_a1-p";
export var scrolledTop = "_a1-9";
export var search = "_a1-q";
export var selectedConversationsCount = "_a1-r";
export var spinner = "_a1-t";
export var strong = "_a1-u";
export var summaryCell = "_a1-v";
export var tableContainer = "_a1-11";
export var tagContainer = "_a1-w";
export var threeDots = "_a1-x";
export var twoLines = "_a1-y";
export var unread = "_a1-z";